module.exports = __webpack_public_path__ + "static/media/mobile1.6129fdb4.png";